(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection search: filter products on the page
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.collection-search');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    const cards = () => Array.from(document.querySelectorAll('.product-grid__item'));

    const applyFilter = () => {
      const q = (input.value || '').trim().toLowerCase();

      cards().forEach(card => {
        const haystack = (card.getAttribute('data-search') || '').toLowerCase();
        if (!q || haystack.includes(q)) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      applyFilter();
    });

    // Optional: live filter while typing (kept on)
    input.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') return; // Enter handled by submit
      applyFilter();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
